import { TableSchema } from '../metadata-schema';
import { dim_br_brin } from './dim_br_brin';
import { dim_vk_vak } from './dim_vk_vak';
import { instelling } from './instelling';
import { Cijferkolomtype } from '../enums/Cijferkolomtype';
import { Niveau } from '../enums/Niveau';

export const fac_ekc_examenkandidaten_en_cijfers: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_ekc_examenkandidaten_en_cijfers",
	"description": "Definitie voor fact tabel fac_ekc_examenkandidaten_en_cijfers uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"ekc_fk_br_vest": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"ekc_fk_br_inst": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"ekc_fk_vk": {
			"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vk_vak
		},
		"ekc_fk_inst": {
			"include": [],
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"ekc_nm_bron": {
			"type": "string",
			"label": "Bron",
			"category": "Examencijfer",
			"example": "cl, duo"
		},
		"ekc_nm_cijfertype": {
			"label": "Cijfertype",
			"category": "Examencijfer",
			"example": "SE-cijfer, CE-cijfer, Eindcijfer",
			"type": "string",
			"schema": Cijferkolomtype
		},
		"ekc_nm_niveau": {
			"label": "Niveau",
			"category": "Examencijfer",
			"example": "VMBO b, VMBO k, VMBO (g)t, HAVO, VWO",
			"type": "string",
			"schema": Niveau
		},
		"ekc_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Examencijfer",
			"example": "2020/2021, 2021/2022, ..."
		},
		"ekc_nr_gem_cijfer": {
			"type": "number",
			"label": "Cijfer",
			"category": "Examencijfer",
			"example": "1,0 - 10,0"
		},
		"ekc_nr_q_cijfers": {
			"type": "integer",
			"label": "Aantal cijfers",
			"category": "Examencijfer",
			"filter": false,
			"grouping": false,
			"example": "1 - ..."
		}
	}
};
